import { render, staticRenderFns } from "./Overdue.vue?vue&type=template&id=17e43e46&"
import script from "./Overdue.vue?vue&type=script&lang=js&"
export * from "./Overdue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports